"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuListClassNames: function() {
        return menuListClassNames;
    },
    useMenuListStyles_unstable: function() {
        return useMenuListStyles_unstable;
    }
});
const _react = require("@griffel/react");
const menuListClassNames = {
    root: 'fui-MenuList'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        i8kkvl: "f16mnhsx",
        Belr9w4: "fbi42co"
    },
    hasMenuContext: {
        Bqenvij: "f1l02sjl"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f16mnhsx{column-gap:2px;}",
        ".fbi42co{row-gap:2px;}",
        ".f1l02sjl{height:100%;}"
    ]
});
const useMenuListStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuListClassNames.root, styles.root, state.hasMenuContext && styles.hasMenuContext, state.root.className);
    return state;
}; //# sourceMappingURL=useMenuListStyles.styles.js.map
